/**
 * Every return rate is reported on matured orders only, so each tooltip has to
 * say so — a reader who does not know that reads an unfinished rate as a low
 * one.
 */
const MATURITY_NOTE_SV =
  "\nFrekvensen beräknas bara på beställningar som är minst 30 dagar gamla, så returer har haft tid att anlända — det är därför det visar N/A tills butiken har varit ansluten lika länge.";

export const translationStatistics_sv_part4 = {
  notificationsDeleteError: "Fel vid borttagning av avisering",
  notificationTopics: [
    { emne: "Abonnement & medlemskab", label: "Prenumeration & medlemskap" },
    { emne: "Annullering", label: "Avbokning" },
    { emne: "Andet", label: "Övrigt" },
    { emne: "Åbningstider", label: "Öppettider" },
    { emne: "Bestilling", label: "Beställning" },
    { emne: "Betaling", label: "Betalning" },
    { emne: "Booking", label: "Bokning" },
    { emne: "Butikker", label: "Butiker" },
    { emne: "FAQ", label: "FAQ" },
    { emne: "Fitness rådgivning", label: "Fitnessrådgivning" },
    { emne: "Fortrydelsesret", label: "Ångerrätt" },
    { emne: "Garanti", label: "Garanti" },
    { emne: "Generel", label: "Allmänt" },
    { emne: "Informationsforespørgsel", label: "Informationsförfrågan" },
    { emne: "Kalorieberegner/Kostplan", label: "Kalorikalkylator / kostplan" },
    { emne: "Kampagner & rabatter", label: "Kampanjer & rabatter" },
    { emne: "Kontakt", label: "Kontakt" },
    { emne: "Kundeservice", label: "Kundservice" },
    { emne: "Lagerstatus", label: "Lagerstatus" },
    { emne: "Levering", label: "Leverans" },
    { emne: "Medlemskab", label: "Medlemskap" },
    { emne: "Ordre", label: "Beställning" },
    { emne: "Pris og rabat", label: "Pris och rabatt" },
    { emne: "Problem med shoppen", label: "Problem med butiken" },
    { emne: "Produkt anbefaling", label: "Produktrekommendation" },
    { emne: "Produktinformation", label: "Produktinformation" },
    { emne: "Profil", label: "Profil" },
    { emne: "Refundering", label: "Återbetalning" },
    { emne: "Reklamation", label: "Reklamation" },
    { emne: "Reservation", label: "Reservation" },
    { emne: "Returnering", label: "Retur" },
    { emne: "Support", label: "Support" },
    { emne: "Teknisk", label: "Teknisk" },
    { emne: "Tilbud", label: "Erbjudande" },
    { emne: "Vask selv", label: "Självbetjäningstvättning" },
    { emne: "Contact & support", label: "Kontakt & support" },
    { emne: "Fejl på shoppen", label: "Butiksfel" },
    { emne: "Kompatabilitet", label: "Kompatibilitet" },
    { emne: "Kontakt & support", label: "Kontakt & support" },
    { emne: "Konto & login", label: "Konto & inloggning" },
    { emne: "Produktvalg", label: "Produktval" },
    { emne: "Support og Kontakt", label: "Support och kontakt" },
  ],

  settingsComingSoon: "Inställningar kommer snart",
  settingsComingSoonDescription:
    "Statistikinställningar och preferenser kommer att vara tillgängliga i en framtida uppdatering. Håll utkik efter fler anpassningsalternativ!",

  totalContactFormulas: "Använda kontaktformulär",
  contactFormulas: "Kontaktformulär",
  contactFormulaConversionRate: "Använde kontaktformulär",

  totalMessagesTooltip:
    "Det totala antalet meddelanden skickade av användare till chatboten under den valda perioden",
  avgMessagesPerDayTooltip:
    "Genomsnittligt antal användarmeddelanden per dag baserat på dagar med aktivitet",
  totalConversationsTooltip:
    "Det totala antalet konversationer (sessioner) startade med chatboten under den valda perioden",
  totalUserRatingsTooltip:
    "Antal gånger användare har gett ett omdöme eller återkoppling efter sin konversation",
  averageRatingTooltip:
    "Genomsnittligt omdöme givet av användare efter sin konversation med chatboten",
  thumbsUpPercentageTooltip: "Andel användare som gav ett positivt omdöme (tummen upp)",
  csatScoreTooltip:
    "Kundnöjdhetspoäng – andel omdömen som var 4 stjärnor eller högre (eller tummen upp)",
  chatbotSatisfactionTooltip:
    "Chatbot-nöjdhet – CSAT-poäng beräknad enbart från konversationer som inte resulterade i en övergång till mänsklig kundservice",
  totalPurchasesTooltip:
    "Antal registrerade köp från användare som haft en konversation med chatboten.\nVi spårar konverteringar tills kunden klickar på 'Betala' och öppnar det externa betalningsfönstret.",
  totalRevenueTooltip:
    "Total omsättning från köp gjorda av användare som interagerat med chatboten.\nVi spårar konverteringar tills kunden klickar på 'Betala' och öppnar det externa betalningsfönstret.",
  storeTotalPurchasesTooltip:
    "Alla beställningar registrerade i den anslutna butiken (Shopify eller Orders API) under perioden, oavsett om kunden pratade med chatboten.",
  storeTotalRevenueTooltip:
    "Total omsättning från alla beställningar i den anslutna butiken (Shopify eller Orders API) under perioden, oavsett om kunden pratade med chatboten.",
  storeAveragePurchaseValueTooltip:
    "Genomsnittligt värde för alla beställningar i den anslutna butiken (Shopify eller Orders API) under perioden, oavsett om kunden pratade med chatboten (butikens omsättning dividerat med antal beställningar).",
  returnRateTooltip:
    "Andel beställningar från användare som pratat med chatboten där minst en vara skickades tillbaka." +
    MATURITY_NOTE_SV +
    "\nObs: kunder som frågar chatboten är inte ett slumpmässigt urval av kunder, så skillnaden mot butikens frekvens är inte i sig bevis på chatbotens effekt.",
  returnValueRateTooltip:
    "Värdet av varor skickade tillbaka som andel av ordervärdet, för användare som pratat med chatboten.\nEndast äkta returer räknas — avbeställningar och goodwill-återbetalningar räknas inte." +
    MATURITY_NOTE_SV,
  returnUnitRateTooltip:
    "Varor skickade tillbaka som andel av köpta varor, för användare som pratat med chatboten.\nDen mest rättvisande frekvensen när kunder ofta returnerar en del av en beställning." +
    MATURITY_NOTE_SV,
  storeReturnRateTooltip:
    "Andel av alla beställningar i den anslutna butiken (Shopify eller Orders API) där minst en vara skickades tillbaka, oavsett om kunden pratade med chatboten." +
    MATURITY_NOTE_SV,
  storeReturnValueRateTooltip:
    "Värdet av varor skickade tillbaka som andel av ordervärdet, för alla beställningar i butiken." +
    MATURITY_NOTE_SV,
  storeReturnUnitRateTooltip:
    "Varor skickade tillbaka som andel av köpta varor, för alla beställningar i butiken." +
    MATURITY_NOTE_SV,
  returnCohortBasisTooltip:
    "Hur många beställningar frekvensen baseras på och den lägsta ålder de måste ha nått.",
  storeConversionRateTooltip:
    "Andel butiksbesök som avslutades med ett köp (alla beställningar dividerat med butikssessioner).\nSessioner mäts av Shopify-webbpixeln, så frekvensen täcker bara perioden sedan pixeln aktiverades.",
  storeConversionRateVisitorsTooltip:
    "Butikens beställningar dividerat med dagliga besökare, som chatboten räknar dem: varje webbläsare en gång om dagen, på sidor där chatboten laddas.\nBesökare som avböjer icke-nödvändiga cookies räknas inte, så frekvensen blir högre än över alla besökare. Endast webbeställningar som lagts sedan besökarna började räknas ingår.",
  averagePurchaseValueTooltip:
    "Genomsnittligt värde av köp gjorda av användare som interagerat med chatboten.\nVi spårar konverteringar tills kunden klickar på 'Betala' och öppnar det externa betalningsfönstret.",
  conversionRateTooltip:
    "Hur många procent slutade med ett köp efter att ha haft en konversation med chatboten.\nVi spårar konverteringar tills kunden klickar på 'Betala' och öppnar det externa betalningsfönstret.",
  fallbackRateTooltip: "Chatboten kände inte till svaret och rekommenderade kundservice",
  resolutionRateTooltip:
    "Andel sessioner som löstes av boten utan att kräva kundservice som nästa steg",
  handoverRequiredRateTooltip:
    "Andel sessioner där ärendet verkligen krävde kundservice eller en manuell process",
  userRequestedCustomerServiceRateTooltip:
    "Andel sessioner där användaren uttryckligen bad om kundservice, livechat eller support",
  ligegyldigRateTooltip:
    'AI-uppskattning av hur många procent av konversationerna enbart består av meningslösa meddelanden som "hej" utan faktiskt innehåll',
  totalContactFormulasTooltip:
    "Antal konversationer där kunden skickade in ett kontaktformulär eller en supportbegäran. Du kan se dessa kontaktformulär genom att använda filterknappen på konversationssidan",
  contactFormulaConversionRateTooltip:
    "Andel konversationer där kunden använde kontaktformuläret eller skickade in en supportbegäran",
  engagementRate: "Engagemangsgrad",
  engagementRateTooltip:
    "Andel besökare som öppnade chatboten och faktiskt skickade ett meddelande",
  conversationSources: "Konversationskällor",
  conversationSourcesTooltip: "Visar hur konversationer startades via olika integrationskällor",
  viewContactFormulas: "Visa kontaktformulär",
  tagsViewExplanation:
    "Du kan se konversationer i varje tagg och kategori genom att filtrera med den lilla filterknappen på konversationssidan",
  clickToViewTags: "Klicka för att visa taggar",
  tagDistribution: "Taggfördelning",
  tagDistributionFor: "Taggfördelning för",
  tagDistributionDescription: "Taggar kopplade till det här ämnet:",
  noTagsFound: "Inga taggar hittades för det här ämnet.",

  qualityMetrics: "Kvalitetsmätvärden",
  statisticsFor: "Statistik för",
  close: "Stäng",
  goToConversations: "Visa konversationer",
  viewPurchases: "Visa köp",
  viewLeads: "Visa leads",
  lackingInfoRate: "Saknar info-frekvens",
  leads: "Kontaktformulär",
  viewConversations: "Visa konversationer",

  companyInfoPlaceholderDescription:
    "Ange företagsinformation, bransch och eventuell kontext som hjälper AI:n att generera bättre insikter",

  uploadFailedContentTooLong:
    "Uppladdningen misslyckades: Innehållet är för långt för bearbetning. Försök att dela upp det i mindre avsnitt eller använd PDF-uppladdning med automatisk uppdelning.",
  uploadFailedAIProcessing:
    "Uppladdningen misslyckades: AI-bearbetningsfel. Kontrollera ditt innehåll och försök igen.",
  uploadFailedInvalidExpiration: "Uppladdningen misslyckades: Ogiltigt format för utgångsdatum.",
  uploadFailedInvalidSchedule: "Uppladdningen misslyckades: Ogiltigt format för schemalagd tid.",
  uploadFailedUserNotFound:
    "Uppladdningen misslyckades: Vald användare hittades inte. Uppdatera sidan och försök igen.",
  uploadFailedMissingFields:
    "Uppladdningen misslyckades: Nödvändig information saknas. Fyll i alla fält.",
  uploadFailedAuthError: "Uppladdningen misslyckades: Användarautentiseringsfel. Logga in igen.",
  uploadFailedNetwork:
    "Uppladdningen misslyckades: Problem med nätverksanslutningen. Kontrollera din anslutning och försök igen.",
  uploadFailedTimeout:
    "Uppladdningen tog för lång tid. Försök igen eller minska uppladdningsstorleken.",
  uploadFailedAuthExpired:
    "Uppladdningen misslyckades: Autentiseringen har gått ut. Logga in igen.",
  uploadFailedServerError: "Fel: kontakta Diverge.",
  uploadFailedGeneric: "Uppladdningen misslyckades: {error}",
  contentMayNeedChunking:
    "Varning: Innehållet beräknas till {tokens} tokens, vilket kan kräva uppdelning för bearbetning. Överväg att dela upp det i mindre avsnitt om uppladdningen misslyckas.",
  pleaseSelectUser: "Välj en användare.",
  pleaseSelectUserBase: "Välj en användare",
  fromAccessibleUsers: "från dina tillgängliga användare",
  toManageTheirData: "för att hantera deras data",
  pleaseSelectOrganization: "Välj en organisation.",
  pleaseSelectOrganizationToManage: "Välj en organisation för att hantera deras data",
  selectOrganization: "Välj organisation",
  selectOrganizationPlaceholder: "Välj organisation",
  noDataFoundForOrganization: "Inga data hittades för {name}",
  errorFetchingOrganizations: "Fel vid hämtning av organisationer",
};
